import { ComponentProps, FC } from 'react'
import { TextButton } from 'react-common'
import { useTranslation } from 'react-i18next'
import { useSelfEnrollment } from '@/views/courses/CourseInfo/hooks/useSelfEnrollment'
import { ButtonContainer } from './ButtonContainer/ButtonContainer'

export const StartSelfEnrollmentCourseButton: FC<Partial<ComponentProps<typeof TextButton>>> = (props) => {
  const { disabled, loading, ...rest } = props
  const { t } = useTranslation()

  const { isSelfEnrollmentLoading } = useSelfEnrollment()

  return (
    <ButtonContainer>
      <TextButton
        data-qa="start-self-enrollment-course-button"
        loading={loading || isSelfEnrollmentLoading}
        disabled={disabled || isSelfEnrollmentLoading}
        size="large"
        {...rest}
      >
        {t('courseDetails.startButton.text')}
      </TextButton>
    </ButtonContainer>
  )
}
